import { writable } from 'svelte/store';

/**
 * Returns a new writable store that will broadcast its new value
 * to all of the provided receiverStores.
 * Note that this is a one-way binding, so any updates to the
 * receiverStores will not update the returned store.
 * The initialValue will _not_ be broadcast to the receiverStores.
 * @param {any} initialValue
 * @param {import('svelte/store').Writable[]} receiverStores
 *
 * @example
 * ```js
 * const someStore = writable(123);
 * const multicastStore = multicast(456, [someStore]);
 * // $someStore === 123, $multicastStore === 456
 * $multicastStore = 789;
 * // $someStore === 789, $multicastStore === 789
 * $someStore = 123;
 * // $someStore === 123, $multicastStore === 789
 * ```
 */
export default function multicast(initialValue, receiverStores = []) {
  const { set, subscribe } = writable(initialValue);
  return {
    set: (val) => {
      set(val);
      receiverStores.forEach((receiver) => receiver.set(val));
    },
    subscribe,
  };
}
